import DateRangePicker from './DateRangePicker.js';
export { DateRangePicker };
export default DateRangePicker;
